import React from 'react';

const Kentucky = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Kentucky Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Disclosure of material facts required; no specific form mandated..
        </li>
        <li>
          Seller’s Disclosure of Property Condition Form: Mandatory for most
          transactions.
        </li>
        <li>
          Flood Plain Disclosure: Required if the property is in a flood plain.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'hhttps://eforms.com/images/2018/08/Kentucky-Real-Estate-Commission-Seller-Property-Disclosure-Form.pdf',
                '_blank'
              );
            }}
          >
            Seller's Disclosure of Property Condition{' '}
          </span>{' '}
          – As Kentucky is not a buyer-beware state, sellers must provide full
          disclosure of the property’s condition prior to signing a purchase
          agreement.
        </li>
      </ol>
    </div>
  );
};

export default Kentucky;
